const browserIsSafari = () => {
  const safari = !!navigator.userAgent.match(/Version\/[\d.]+.*Safari/);
  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  return safari || iOS ? true : false;
};
const isIosDevice = () => {
  return typeof navigator !== "undefined" && (navigator.userAgent.match(/(iPod|iPhone|iPad)/g) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) && !window.MSStream;
};
export {
  browserIsSafari,
  isIosDevice
};
//# sourceMappingURL=browser-detection.js.map
